
/**
 * Helper to resolve static asset paths (images, icons) correctly
 * across Local Development (with sub-path bases) and Production (Unified Domain).
 * 
 * @param path - The absolute path to the asset (e.g., "/Logos/Logo.png")
 */
export const getAssetUrl = (path: string): string => {
    // Ensure path starts with /
    const cleanPath = path.startsWith('/') ? path : `/${path}`;

    // In DEVELOPMENT (npm run dev):
    // Apps are served from subpaths (e.g. localhost:5182/control-asistencia/).
    // Static assets in 'public' are served relative to that base.
    // So we MUST prepend the BASE_URL.
    if (import.meta.env.DEV) {
        const base = import.meta.env.BASE_URL || '/';
        // Avoid double slashes if base is "/"
        if (base === '/') return cleanPath;
        
        // Remove trailing slash from base if present to join cleanly
        const cleanBase = base.endsWith('/') ? base.slice(0, -1) : base;
        return `${cleanBase}${cleanPath}`;
    }

    // In PRODUCTION (archicoreanalytic.com):
    // Assets live at the domain root (/Logos/...), regardless of the app's base path.
    // The base path is used for JS/CSS loading, but shared assets are at root.
    return cleanPath;
};
